import { CreateActionTask } from "../../types";

export const defaultValues = (data?: CreateActionTask) => {
  return {
    mr_document_code: data?.mr_document_code ?? "",
    mr_document_name: data?.mr_document_name ?? "",
    description: data?.description ?? ""
  };
};